import React, { createContext, useState } from 'react';

export const DataContext = createContext();
export const DataProvider = ({ children }) => {
  const [data] = useState([]);

  return (
    <DataContext.Provider value={data}>
      {children}
    </DataContext.Provider>
  );
};
